<template>
	<div v-if="mode == 'sendEmail'">
		<template v-if="!resent">
			<span class="mb-4 mt-8 frontpage-text d-block text-center">Still can't find the link?</span>
			<span v-if="!enableResend" class="frontpage-text">You can resend it in {{ countDown }} seconds.</span>
			<a v-else href="#" @click.prevent="resendVerificationEmail">
				<span class="frontpage-text d-block text-center text-decoration-underline font-weight-bold">Resend it.</span>
			</a>
		</template>

		<span v-else-if="resent && !contactSupport" class="mt-8 frontpage-text d-block text-center font-weight-bold">Link sent to your email.</span>
		<span v-else-if="resent && contactSupport" class="mt-8 frontpage-text d-block text-center font-weight-bold">We couldn't verify your email. Please contact <a href="https://fylm.ai/contact/" target="_blank">our support.</a></span>
	</div>

    <div v-else-if="mode == 'verifyingEmail'" class="verifying-email-container mt-10">
        <v-progress-circular indeterminate color="var(--primary)" size="50" width="5"></v-progress-circular>
        <span class="onboarding-text">Verifying email</span>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Cookies from 'js-cookie'

export default {
	name: "VerifyEmail",

	async mounted() {
        if (this.$route.query.signature) {
			this.verifyEmail();
		}

        if (Cookies.get('resendEmailVerificationAfterLogin')) {
            Cookies.remove('resendEmailVerificationAfterLogin');
            this.resendVerificationEmail();
            return;
        }

		this.countDownTimer();
	},

	data: function() {
		return {
			mode: 'sendEmail',
			message: null,
			countDown: 60,
			enableResend: false,
			resent: false,
			contactSupport: false,
		};
	},

	computed: {
		...mapGetters("User", ["user"]),
		...mapState("User", ["account"]),
	},

	methods: {
		countDownTimer() {
			if (this.countDown > 0) {
				setTimeout(() => {
					this.countDown -= 1;
					this.countDownTimer();
				}, 1000);
			} else {
				this.enableResend = true;
			}
		},

		resendVerificationEmail() {
			this.resent = true;
			this.$apiService.post("email/resend", { email: this.user.email })
				.catch(err => {
					if (err.response.status == 403) {
						this.contactSupport = true;
						this.$snackbar("Email verification process disabled. Please contact support", "error");
					}
				})
		},

		verifyEmail() {
            this.mode = 'verifyingEmail';

			this.$apiService
				.post("email/verify", null, {
					params: {
						expires: this.$route.query.expires,
						hash: this.$route.query.hash,
						signature: this.$route.query.signature,
						id: this.$route.query.id,
					},
				})
				.then(response => {
					if (this.account.onboarding == "completed") {
						this.$router.push({ name: "account.profile" });
						this.$snackbar("Email successfully updated.", "success");
                        return;
					}

                    if (!this.user) {
                        this.$router.push({ name: "login" });
                        this.$snackbar("Email successfully verified. Please log in below to continue.", "success");
                        return;
                    }

					this.$router.push({ name: "onboarding.get-started" });
				})
				.catch(err => {
					this.mode = "sendEmail";

                    if (this.user) {
                        this.$snackbar("Email verification token expired or invalid.", "error");
                    }

                    if (!this.user) {
                        this.$snackbar("Email verification token expired or invalid.", "error");
                        Cookies.set('resendEmailVerificationAfterLogin', true);
                        this.$router.push({ name: "login" });
                    }
				})
		},
	},
};
</script>

<style lang="scss" scoped>
	i {
		color: var(--primary);
		font-size: 4rem;
	}

    .verifying-email-container {
        display: flex;
        flex-direction: column;
        align-items: center;

        > span {
            margin-top: 15px;
        }
    }
</style>
